module.exports = __webpack_public_path__ + "img/cheers_new.5e8bf477.svg";